import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MiniCalendarComponent} from "./mini-calendar.component";
import {EventModule} from "../event/event.module";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {MatNativeDateModule, MatRippleModule} from "@angular/material/core";
import {MatCardModule} from "@angular/material/card";
import {MatDatepickerModule} from "@angular/material/datepicker";



@NgModule({
    declarations: [MiniCalendarComponent],
    exports: [MiniCalendarComponent],
    imports: [
        CommonModule,
        EventModule,
        InfiniteScrollModule,
        MatRippleModule,
        MatDatepickerModule,
        MatCardModule,
        MatNativeDateModule
    ]
})
export class MiniCalendarModule { }
